import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { I18nModule, provideConfig } from '@spartacus/core'
import { ActiveFacetsModule, IconModule } from '@spartacus/storefront'
import { EbProductFacetNavigationComponent } from './eb-product-facet-navigation.component'
import { EbFacetListModule } from './facet-list/eb-facet-list.module'

@NgModule({
  imports: [CommonModule, EbFacetListModule, ActiveFacetsModule, IconModule, I18nModule],
  providers: [
    provideConfig({
      cmsComponents: {
        ProductRefinementComponent: {
          component: EbProductFacetNavigationComponent
        }
      }
    })
  ],
  declarations: [EbProductFacetNavigationComponent],
  exports: [EbProductFacetNavigationComponent]
})
export class EbProductFacetNavigationModule {}
